<template>
  <!-- NOTE (TEMPLATE) to show the proposals -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/manager/decidedMeetings'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-proposals) to show the proposals list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        :filterIncludedFields="filterOn"
        empty-text="هنوز طرحی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <!-- NOTE (<a>) to show the proposal details -->
            <a
              :href="'/manager/meeting/' + data.item.project_id"
              target="_blank"
              class="btn btn-primary text-light"
              style="width: 100%"
              >جزییات</a
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      filter: "",
      filterOn: [],

      fields: [
        { key: "index", label: "ترتیب" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "project_code", label: "کد طرح" },
        { key: "register_date", label: "تاریخ ثبت" },
        { key: "project_status", label: "وضعیت" },
        { key: "university", label: "دانشگاه" },
        { key: "last_update", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      items: [],

      isBusy: true,
    };
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },

  mounted() {
    // NOTE (MOUNTED) to show the data of this page
    this.$http
      .post(
        this.baseUrl + "/setad/manager/decidedRequests",
        { projectType: "meeting" },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        }
      )
      .then((res) => {
        this.items = res.data;
        this.totalRows = this.items.length;
        this.isBusy = false;
      })
      .catch((err) => {
        console.log(err);
        this.toast(err.response.data, "error");
        if (err.response.status == 403 || 401) {
          this.$router.push({
            path: "/unauthorize",
            query: { return: window.location.pathname },
          });
        }
      });
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
